/**
 * Multi Content Teasers
 *
 * @module components/multi-content-teasers
 */

import Component from './component';
import CardFocusVisible from './card-focus-visible';

export default (($, /* eslint-disable */ window, undefined /* eslint-enable */) => {
  'use strict';

  /**
   * MultiContentTeasers component class
   */
  class MultiContentTeasers extends Component {
    /**
     * Constructor
     */
    constructor(element, options = {}) {
      super(element, options);
      this.name = 'multi-content-teasers';
    }

    /**
     * Main initializer
     * 
     * @returns void
     */
    init() {
      const el = this.element;

      if (el.hasClass(this.initializedClass)) {
        return;
      }

      el.addClass(this.initializedClass);
      
      new CardFocusVisible(this.element, {
        cardSelector: MultiContentTeasers.selectors.cardItem
      });
    }
  }

  MultiContentTeasers.selectors = {
    cardItem: '.card-multi-content'
  };

  return MultiContentTeasers;
})(jQuery, window);